import { getCurrentDate } from "./helpers";

export const initialOrderState = {
    operationID: 0,
    operationDate: getCurrentDate("-"),
    operationDocumentNumber: "",
    operationCorrelative: 0,
    operationCode: "",
    code: "",
    percentageIgv: 18,
    conditionIgv: "02",
    operationNumberItems: 0,
    operationItems: [],
    operationStatus: "01",
    operationStatusDisplay: "PENDIENTE",
    operationActionID: "NA",
    operationTypeID: "08",
    operationDocumentTypeID: "03",
    operationAmountBase: "",
    operationAmountIgv: "",
    operationAmountTotal: "",
    supplierDocumentType: "06",
    supplierFirstSurname: "",
    supplierFiscalAddress: "",
    supplierID: "0",
    supplierSecondSurname: "",
    supplierDocumentNumber: "20297182456",
    supplierName: "",
    warehouseID: 0,
    warehouseName: "",
    warehouseCategory: "",
    userID: 0,
    totalTaxable: "0.00",
    totalIgv: "0.00",
    totalPayable: "0.00",
    totalFree: "0.00",
    totalFreeValue: "0.00",
    affectsStock: true,
};

export const initialOptionState = {
    operationID: 0,
    operationDetailID: 0,
    productTariffID: 0,
    productID: 0,
    productName: "",
    productStockMin: 0,
    productStockMax: 0,
    productStock: 0,
    percentageDiscount: 0,
    pricePurchase: 0,
    priceSale: 0,
    unitaryPriceSale: 0,
    unitName: "",
    unitID: 0,
    quantityOrdered: 0,
    quantity: 0,
    price: 0,
    amount: 0,
    discount: 0,
    amountDiscount: 0,
    igv: 0,
    amountIgv: 0,
    subtotal: 0,
    tariffs: [],
    grammage: "",
    expireDate: getCurrentDate("-"),
    sku: "",
    condition: "01",
    unitPrice: "0.000000",
    grossAmount: "0.00",
    discountAmount: "0.00",
    netAmount: "0.00",
    taxableAmount: "0.00",
    igvAmount: "0.00",
    totalWithIgv: "0.00",
    isFree: false,
    taxType: "GRAVADO",
    freeAmount: 0,
    freeIgvAmount: 0,
};
